import { SVGProps, Ref, forwardRef } from 'react';

export const LockClosedFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.893 4.39c1.77.613 2.103 2.113 2.103 5.608 0 5.249-.75 5.998-5.998 5.998-5.25 0-5.999-.75-5.999-5.998 0-3.495.332-4.995 2.103-5.607C4.425 2.014 5.54 0 7.997 0c2.458 0 3.573 2.013 3.896 4.39m-1.468-.295c-.117-.594-.293-1.118-.527-1.54-.416-.749-.983-1.155-1.9-1.155-.918 0-1.485.406-1.9 1.155-.235.422-.412.946-.528 1.54.677-.071 1.479-.096 2.428-.096s1.75.025 2.427.096M8.698 8.332v3.332h-1.4V8.332z"
            fill="currentColor"
        />
    </svg>
));
LockClosedFilledSize16Glyph.displayName = 'LockClosedFilledSize16Glyph';
